import { render, staticRenderFns } from "./add-quote.vue?vue&type=template&id=ffd11816&scoped=true"
import script from "./add-quote.vue?vue&type=script&lang=js"
export * from "./add-quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd11816",
  null
  
)

export default component.exports